import React from 'react';
import { useCookies } from 'react-cookie';

const SESSION_ID = 'sessionId';

const options = { path: '/' };

export const useSessionId = () => {
  const [cookies, setCookie, removeCookie] = useCookies([SESSION_ID]);

  const setSessionId = React.useCallback(
    (sessionId: string) => {
      setCookie(SESSION_ID, sessionId, options);
    },
    [setCookie]
  );

  const removeSessionId = React.useCallback(() => {
    removeCookie(SESSION_ID, options);
  }, [removeCookie]);

  return {
    sessionId: cookies.sessionId as string,
    setSessionId,
    removeSessionId,
  };
};

export const useCookie = (COOKIE_NAME: string) => {
  const [cookies, setCookie, removeCookie] = useCookies([COOKIE_NAME]);

  const setCookieFn = React.useCallback(
    (name: string) => {
      setCookie(COOKIE_NAME, name, options);
    },
    [setCookie]
  );

  const removeCookieFn = React.useCallback(() => {
    removeCookie(COOKIE_NAME, options);
  }, [removeCookie]);

  return {
    cookie: cookies.name as string,
    setCookie: setCookieFn,
    removeCookie: removeCookieFn,
  };
};
